// @flow

export const fontFamily = {
  display: 'Gilroy, "Open Sans", OpenSans, Arial, "Helvetica Neue", Helvetica, sans-serif',
  sansSerif: '"Open Sans", OpenSans, "Helvetica Neue", Helvetica, Arial, sans-serif',
};
